/**
 * 奖励&成就页面-成就tab内容
 * auth：xuyan
 * time：2023-06-13 18:57
 */

import { useState } from 'react';
import classnames from 'classnames';
import './Achievement.scss';
import { Toast } from 'antd-mobile';
import { Space, SpinLoading } from 'antd-mobile';

const Achievement = (props: any) => {
  const { achieveList } = props;

  const [selected, setShareIndex] = useState(-1);
  // const [top, setTop] = useState(0);

  const handleSlectedShare = (index: any) => {
    if (achieveList[index]?.status == '0') return;
    if (achieveList[index]?.status == '1') {
      return setShareIndex(index);
    }
    Toast.show({
      content: '系统繁忙，请稍后再试～',
    });
  };

  //点击成就图分享
  const handleShare = () => {
    console.log('成就图分享');
    props.handleShare(achieveList[selected]?.img);
  };

  // useEffect(() => {
  //   const obj: any = document
  //     .getElementById('achievement')
  //     ?.getBoundingClientRect();
  //   console.log('%cAchievement.tsx line:42 obj', 'color: #007acc;', obj);
  //   setTop(obj.top);
  // }, []);

  return (
    <div className='achievement' id='achievement'>
      <div className='achievement-lists'>
        {achieveList?.map((item: any, index: number) => {
          return (
            <div
              key={index}
              className={classnames(
                'achievement-list',
                index === 0 && 'alone',
                item.status * 1 === 1 && 'unlock',
                index === selected && 'selected'
              )}
              onClick={() => handleSlectedShare(index)}
            >
              <div className='achievement-list-pic'>
                {item.status * 1 === 1 && (
                  <div className='achievement-list-pic__mask'></div>
                )}
                {item.status * 1 === 1 && <img src={item.img} alt='' />}
              </div>
              <div className='achievement-list-desc'>{item.title}</div>
            </div>
          );
        })}
      </div>
      <div className='achievement-share' onClick={handleShare}></div>
      <div
        onClick={() => {
          let obj: any = document.getElementById('achievement');
          obj.scrollIntoView();
        }}
        className='achievement-backtop'
      ></div>
    </div>
  );
};

export default Achievement;
